<template>
	<div class="calendar-container">
		<div class="calendar-header">
			<button class="nav-button" @click="prevMonth">上月</button>
			<h2 class="calendar-title">{{ currentMonth }}</h2>
			<button class="nav-button" @click="nextMonth">下月</button>
		</div>
		<div class="calendar-grid">
			<!-- 星期标题 -->
			<div class="calendar-day calendar-day-header" v-for="day in weekDays" :key="day">
				{{ day }}
			</div>
			<!-- 日期格子 -->
			<div class="calendar-day" :class="{ 'other-month': !day.isCurrentMonth, choose: localChoose == day.date }"
				v-for="day in calendarDays" :key="day.date" @click="selectOne(day)">
				{{ day.day }}
				<div class="signa" v-if="day.status == 1">*</div>
				<div class="signb" v-if="day.status == 2">*</div>
				<div class="attendance-status" v-if="day.isCurrentMonth && day.courseNum > 0">
					{{ day.courseNum }}节
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import utils from '../utils/index.js'
	export default {
		name: "AttendanceCalendar",
		props: {
			classlist: {
				type: Array,
				default: () => [],
			},
			choose: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				currentDate: new Date(), // 当前显示的日期
				localChoose: utils.getNowDate('ymd'), // Renamed to avoid conflict
				weekDays: ["一", "二", "三", "四", "五", "六", "日"], // 星期标题
			};
		},
		watch: {
			choose(newVal) {
				this.localChoose = newVal;
			},
		},
		computed: {
			currentMonth() {
				return this.currentDate.toLocaleDateString("zh-CN", {
					year: "numeric",
					month: "long",
				});
			},
			calendarDays() {
				const date = new Date(this.currentDate);
				const year = date.getFullYear();
				const month = date.getMonth();

				const firstDay = new Date(year, month, 1);
				const lastDayOfPrevMonth = new Date(year, month, 0);
				const lastDay = new Date(year, month + 1, 0);

				const days = [];

				var prevMonthDays = firstDay.getDay();
				if (prevMonthDays == 0) {
					prevMonthDays = 7
				}
				for (let i = prevMonthDays - 2; i >= 0; i--) {
					const day = lastDayOfPrevMonth.getDate() - i;
					days.push(this.createDayObject(year, month - 1, day, false));
				}

				for (let i = 1; i <= lastDay.getDate(); i++) {
					days.push(this.createDayObject(year, month, i, true));
				}

				const nextMonthDays = 42 - days.length;
				for (let i = 1; i <= nextMonthDays; i++) {
					days.push(this.createDayObject(year, month + 1, i, false));
				}
				return days;
			},
		},
		methods: {
			createDayObject(year, month, day, isCurrentMonth) {
				const date = new Date(year, month, day);
				return {
					date: utils.chinaStandard(date),
					day: day,
					isCurrentMonth,
					status: this.AttendanceStatus(date),
					courseNum: this.mockAttendanceStatus(date),
				};
			},
			AttendanceStatus(date) {
				const currentDate = utils.chinaStandard(new Date());
				const targetDate = utils.chinaStandard(date);
				if (targetDate < currentDate) {
					for (let i = 0; i < this.classlist.length; i++) {
						if (utils.chinaStandard(this.classlist[i].courseDate) == utils.chinaStandard(date)) {
							if (this.classlist[i].courseNum === 0) {
								return 0;
							} else if (this.classlist[i].attendStatus === 0) {
								return 2;
							} else {
								return 1;
							}
						}
					}
				} else if (targetDate > currentDate) {
					return 0;
				} else {
					return 3;
				}
			},
			mockAttendanceStatus(date) {
				for (var i = 0; i < this.classlist.length; i++) {
					if (utils.chinaStandard(this.classlist[i].courseDate) == utils.chinaStandard(date)) {
						return this.classlist[i].courseNum;
					}
				}
			},
			prevMonth() {
				this.localChoose = utils.getNowDate('ymd'),
				this.currentDate = new Date(
					this.currentDate.getFullYear(),
					this.currentDate.getMonth() - 1,
					1
				);
				var date = utils.chinaStandard(this.currentDate);
				this.$emit('onyearmonth', date);
			},
			nextMonth() {
				this.localChoose = utils.getNowDate('ymd'),
				this.currentDate = new Date(
					this.currentDate.getFullYear(),
					this.currentDate.getMonth() + 1,
					1
				);
				var date = utils.chinaStandard(this.currentDate);
				this.$emit('onyearmonth', date);
			},
			selectOne(item) {
				if (!item.isCurrentMonth) {
					this.$message({
						message: '时间不在可选范围内',
						type: 'warning',
					});
					return false;
				}
				this.localChoose = item.date;
				this.$emit('update:choose', item.date);
				this.$emit('onclick', item.date);
			},
		},
	};
</script>

<style scoped>
	/* 样式保持不变 */
</style>



<style scoped>
	/* 样式保持不变 */
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body {
		font-family: Arial, sans-serif;
		background-color: #f5f5f5;
	}

	.calendar-container {
		max-width: 800px;
		margin: 20px auto;
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.calendar-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
		padding: 10px;
		background: #f8f9fa;
		border-radius: 4px;
	}

	.nav-button {
		padding: 8px 16px;
		background: #007bff;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: background 0.3s;
	}

	.nav-button:hover {
		background: #0056b3;
	}

	.calendar-title {
		font-size: 1.5em;
		color: #333;
	}

	.calendar-grid {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: 2px;
	}

	.calendar-day {
		padding: 7px;
		text-align: center;
		background: #f8f9fa;
		border-radius: 4px;
		min-height: 40px;
	}

	.calendar-day-header {
		font-weight: bold;
		background: #e9ecef;
	}

	.attendance-status {
		font-size: 0.8em;
		margin-top: 5px;
		padding: 2px 5px;
		border-radius: 3px;
	}

	.normal {
		background: #28a745;
	}

	.late {
		background: #ffc107;
	}

	.absent {
		background: #dc3545;
	}

	.rest {
		background: #6c757d;
	}

	.other-month {
		opacity: 0.5;
	}

	.choose {
		background-color: #9fcdff;
		color: #fff !important;
		border-radius: 10px;
	}

	.signa {
		font-style: normal;
		height: 8px;
		color: #f6a943;
	}

	.signb {
		font-style: normal;
		height: 7px;
		color: #0caaf1;
	}
</style>